module.exports = "<vue-component class=\"tr-page__wrapper\" component=\"OrganizationMapPage\" v-props=\"currentParams\"></vue-component>"